 <template>
  <div>
    <el-table style="width: 100%" :cell-class-name="getClassName" :data="data" border>
      <el-table-column label="操作" width="282">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.file && !scope.row.fileList" type="primary" icon="el-icon-download" @click="download(selectDetail.id,scope.row.fileAnnex)">下载文件</el-button>
          <div v-if="scope.row.file && !!scope.row.fileList">
            <el-link v-for="(fileItem, fileIndex) in scope.row.fileList":key="fileIndex" type="primary" :underline="false"
                     icon="el-icon-download" style="display: block; text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                     :title="fileItem !== 'completeAttachments' ? fileItem : '全部'"
                     @click="download(selectDetail.id, scope.row.fileAnnex, fileItem !== 'completeAttachments' ? (scope.row.fileList.includes('completeAttachments')? encodeURIComponent(fileItem):'' ): fileItem)">
              {{ fileItem !== 'completeAttachments' ? fileItem : '全部' }}
            </el-link>
          </div>
<!--          <el-button size="mini" v-if="scope.row.file" type="success" icon="el-icon-printer" @click="print(selectDetail.id,scope.row.fileAnnex)">预览打印</el-button>-->
        </template>
      </el-table-column>
      <el-table-column label="邮寄说明" prop="name" ></el-table-column>
      <el-table-column label="是否邮寄">
        <template slot-scope="scope">
          {{scope.row.number}}
        </template>
      </el-table-column>
      <el-table-column label="是否扫描">
        <template slot-scope="scope">
          {{scope.row.scanningFlag}}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark">
        <template slot-scope="scope">
          <w-ellipsis-and-look :text="scope.row.remark" :column="{title:scope.row.name + '备注'}"></w-ellipsis-and-look>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import {attachmentMail} from "@/api/dilivery/mail";
import {mailingContent} from "@/utils/data/tableCol/mail/mailingContent";
import Template from "@/views/systems/Template/Template.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
const baseURL = process.env.VUE_APP_BASE_API
import { fileDownload } from "@/utils/downFileUtils";
export default {
  name: "MailingContent",
  components: { Template},
  props: {
    selectDetail:{
      default:()=>({})
    }
  },
  data(){
    return{
      data:[]
    }
  },
  computed: {
    columns() {
      return mailingContent()
    }
  },
  watch: {
    selectDetail:{
      handler(newVal){
        if(newVal && Object.keys(newVal)){
          let contract = {
            name:'合同',
            number:newVal.mailingContent.numberOfContract?newVal.mailingContent.numberOfContract + '份':'否',
            scanningFlag:newVal.mailingContent.contractScanningFlag?'是':'否',
            file:newVal.mailingContent.numberOfContract>0 || newVal.mailingContent.contractScanningFlag,
            fileList:null,
            fileAnnex:'CONTRACT_ANNEX' ,
            remark:newVal.mailingContent.contractExplain
          }
          if(contract.number !== '否' || contract.scanningFlag !== '否'){
            this.data.push(contract)
          }
          // let invoice = {
          //   name:'发票',
          //   number:newVal.mailingContent.numberOfInvoice?newVal.mailingContent.numberOfInvoice + '份':'否',
          //   scanningFlag:'NA',
          //   file:newVal.mailingContent.numberOfInvoice>0,
          //   fileAnnex:'INVOICE_ATTACHMENTS',
          //   remark:newVal.mailingContent.invoiceExplain
          // }
          // if(invoice.number !== '否'){
          //   this.data.push(invoice)
          // }
          let report = {
            name:'结题报告',
            number:newVal.mailingContent.numberOfReport?newVal.mailingContent.numberOfReport + '份':'否',
            scanningFlag:newVal.mailingContent.reportScanningFlag?'是':'否',
            file:Object.keys(newVal.mailAttachment['REPORT_ANNEX']).length>0,
            fileList:this.sortObjectKeys(newVal.mailAttachment['REPORT_ANNEX'],'completeAttachments'),
            fileAnnex:'REPORT_ANNEX',
            remark:newVal.mailingContent.reportExplain
          }
          if(report.number !== '否' || report.scanningFlag !== '否'){
            this.data.push(report)
          }
          let license = {
            name:'营业执照',
            number:newVal.mailingContent.numberOfLicense?newVal.mailingContent.numberOfLicense + '份':'否',
            scanningFlag:'NA',
            file:newVal.mailingContent.numberOfLicense>0,
            fileList:null,
            fileAnnex:'LICENSE_ANNEX',
            remark:newVal.mailingContent.licenseExplain
          }
          if(license.number !== '否'){
            this.data.push(license)
          }
          let reimbursement = {
            name:'报账资料',
            number:newVal.mailingContent.numberOfReimbursementFile?newVal.mailingContent.numberOfReimbursementFile + '份':'否',
            scanningFlag:newVal.mailingContent.reimbursementScanningFlag?'是':'否',
            file:Object.keys(newVal.mailAttachment['REIMBURSEMENT_ANNEX']).length>0,
            fileList:this.sortObjectKeys(newVal.mailAttachment['REIMBURSEMENT_ANNEX'],'completeAttachments'),
            fileAnnex:'REIMBURSEMENT_ANNEX',
            remark:newVal.mailingContent.reimbursementExplain
          }
          if(reimbursement.number !== '否' || reimbursement.scanningFlag !== '否'){
            this.data.push(reimbursement)
          }
          let mail = {
            name:'邮寄资料',
            number:newVal.mailingContent.numberOfSingleMailFile?newVal.mailingContent.numberOfSingleMailFile + '份':'否',
            scanningFlag:'NA',
            file:Object.keys(newVal.mailAttachment['MAIL_ANNEX']).length>0,
            fileList:this.sortObjectKeys(newVal.mailAttachment['MAIL_ANNEX'],'completeAttachments'),
            fileAnnex:'MAIL_ANNEX',
            remark:newVal.mailingContent.singleMailFileExplain
          }
          if(mail.file){
            this.data.push(mail)
          }
        }
      },
      immediate:true
    }
  },
  mounted() {
  },
  methods: {
    async download(id,type,name){
      try {
        const fileName = name?('/' + name):''
        let url = `/contract_api/mail-info/attachment/${id}/${type}${fileName}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
       
      } catch (error) {
        console.log(error);
      }
    },
    async print(id,type){
      try {
        const response = await attachmentMail(id,type);
        fileDownload(response.file,response.fileName,true)
      } catch (error) { console.log(error); }
    },
    getClassName({ row, column, rowIndex, columnIndex }) {
      if(columnIndex!==2 && columnIndex !==3){
        return 'rowUp'
      }
      if(['否', 'NA'].includes(row.scanningFlag) && columnIndex === 3){
        return 'rowUp'
      }
      if(['否', 'NA'].includes(row.number) && columnIndex === 2){
        return 'rowUp'
      }
      return 'column'
    },
    sortObjectKeys(object,key){
      let list = Object.keys(object)
      if(list.includes(key)){
        list = list.filter(item => item !== key)
        list.push(key)
      }
      return list
    }
  }
}
</script>

<style>
.column{
  background: #ebe2ac!important;
}
.rowUp{
  background: #ffffff !important;
}
.el-table.el-table--enable-row-hover.el-table__body tr:hover > td {
  background: transparent !important;
}
</style>
